import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import {
  MatPaginator,
  MatSnackBar,
  MatTableDataSource,
} from "@angular/material";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { ConfigurarPastaServiceService } from "app/configurar-pasta-service.service";
import { PermissoesService } from "app/service/usuario/permissoes.service";

import { DadosArquivisticosService } from "../dados-arquivisticos/dados-arquivisticos.service";
import { EditPropertieDialogComponent } from "../dialog/edit-propertie-dialog/edit-propertie-dialog.component";
import { SavePropertieDialogComponent } from "../dialog/edit-propertie-dialog/save-propertie-dialog/save-propertie-dialog.component";
import { DialogConfirmComponent } from "../dialog/dialog-confirm/dialog-confirm.component";

@Component({
  selector: "app-edit-properties",
  templateUrl: "./edit-properties.component.html",
  styleUrls: ["./edit-properties.component.scss"],
})
export class EditPropertiesComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  private arrayString: string;
  superUser = false;
  superUserGeneral = false;
  authorityUser = [];
  loading = true;
  public rotaRedirect;
  public rota;
  aspects: any[];
  nodeId: number;
  clienteId: number;
  tipoId: number;
  tipoName: String = "";
  displayedColumns = [
    "title",
    "name",
    "description",
    "type",
    "mandatory",
    "defaultValue",
    "action",
  ];
  dataSource = new MatTableDataSource<any[]>([]);

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private configPastaService: ConfigurarPastaServiceService,
    private dadosService: DadosArquivisticosService,
    private activeRoute: ActivatedRoute,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private permissoesService: PermissoesService
  ) {
    this.getGlobalPermissionUser();
    this.route.params.subscribe(
      (params) => {
        this.clienteId = params["clienteId"];
        this.tipoId = params["tipoId"];
        if (this.clienteId) {
          this.getPermissionCliente(this.clienteId);
        }
      },
      (error) => {
        console.error(error);
        this.loading = false;
        this.openSnackBar(
          "Ocorreu um erro ao buscar url, tente novamente em alguns instantes",
          true
        );
      }
    );
    this.rotaRedirect = localStorage.getItem("ROUTER_PROP");
    console.log(this.rotaRedirect);
    if (this.rotaRedirect === "not_global_type") {
      this.rota = "configurar-tipo-cliente";
    } else {
      this.rota = "edit-types";
    }
  }

  ngOnInit() {
    this.getAllProperties();
    this.configPastaService.isChangedNode.subscribe(() => {
      this.getAllProperties();
    });
  }

  getAuthorityUser() {
    if (this.authorityUser.includes("SUPER_USER")) {
      this.superUserGeneral = true;
    }
  }

  getGlobalPermissionUser() {
    this.permissoesService.getPermissionsInUserLogged().subscribe(
      (data: any[]) => {
        this.authorityUser = data.map((el) => el.name);
        this.getAuthorityUser();
        this.loading = false;
      },
      (err) => {
        this.loading = false;
      }
    );
  }

  getPermissionCliente(idCliente: number) {
    this.loading = true;
    this.permissoesService.getPermissionEmpresa(idCliente).subscribe(
      (data) => {
        const arrayAuthorityCliente: any[] = [];
        data.forEach((el) => {
          arrayAuthorityCliente.push(el.authority);
        });
        this.permissoesService.setItemAuthority(
          "authority-Empresa",
          arrayAuthorityCliente
        );
        this.getAuthority();
        this.loading = false;
      },
      (err) => {
        this.loading = false;
        console.error(err);
        this.openSnackBar("Ocorreu um erro, tente novamente mais tarde", true);
      }
    );
  }

  getAuthority() {
    this.arrayString =
      this.permissoesService.getItemAuthority("authority-Empresa");
    if (this.arrayString.includes("SUPER_USER")) {
      this.superUser = true;
    }
  }

  getAllProperties() {
    this.loading = true;
    this.activeRoute.params.subscribe(
      (params) => {
        this.nodeId = params["tipoId"];
        this.clienteId = params["clienteId"];

        this.dadosService.listarNodeDicionario(this.nodeId).subscribe(
          (data) => {
            this.tipoName = data.title;
            this.dataSource.data = data.propriedades;
            this.loading = false;
          },
          (err) => {
            this.handleError(err, "ao carregar aspectos");
          }
        );
      },
      (err) => {
        this.handleError(err, "ao buscar o tipo documental");
      }
    );
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  openPropriedadeSave() {
    this.router.navigate([
      `adicionar-propriedade/${
        this.clienteId ? this.clienteId + "/" + this.tipoId : this.tipoId
      }`,
    ]);
  }

  confirmDelete(id) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {
        name: "Deseja apagar esta propriedade ?",
        from: "edit-properties.component.ts",
      },
    });
    dialogRef.afterClosed().subscribe((confirmed: any) => {
      if (confirmed.apagar === true) {
        this.deleteData(id);
      }
    });
  }

  deleteData(id) {
    this.configPastaService.deleteProperty(id).subscribe(
      (data) => {
        console.log(data);
        this.openSnackBar("Propriedade excluída com sucesso !", false);
        this.getAllProperties();
      },
      (error) => {
        console.error(error);
        this.openSnackBar("Erro ao tentar excluir a propriedade !", true);
      }
    );
  }

  openPropEditDialog(prop?) {
    let largura;
    if (innerWidth < 400) {
      largura = innerWidth - 50 + "px";
    } else {
      largura = innerWidth / 2 + "px";
    }
    console.log(this.tipoId);
    const dialogRef = this.dialog.open(EditPropertieDialogComponent, {
      data: { idDoTipo: this.tipoId, clientId: this.clienteId, prop },
      width: largura,
    });
    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result) {
          this.getAllProperties();
        }
      },
      (err) => {
        this.handleError(
          err,
          "Ocorreu um erro, tente novamente em alguns instantes"
        );
      }
    );
  }

  handleError(error, msg) {
    this.loading = false;
    console.error(error);
    this.openSnackBar(
      `Ocorreu um erro ${msg}, tente novamente em alguns instantes`,
      true
    );
  }

  openSnackBar(message: string, isErr: boolean) {
    this._snackBar.open(message, "", {
      horizontalPosition: "right",
      verticalPosition: "top",
      duration: 3000,
      panelClass: isErr ? ["error-snackbar"] : ["success-snackbar"],
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/edit-properties/edit-properties.component.ts